import { get, put } from '../utils/request';
import { SystemConfig } from '../types';

// 获取系统配置列表
export async function getConfigList(): Promise<SystemConfig[]> {
  return get<SystemConfig[]>('/admin/configs');
}

// 更新系统配置
export async function updateConfig(configKey: string, configValue: string): Promise<void> {
  return put('/admin/configs', { configKey, configValue });
}

// 获取单个配置值（需要认证）
export async function getConfigValue(key: string): Promise<{ value: string }> {
  return get<{ value: string }>(`/admin/configs/${key}`);
}

// 获取公开配置值（无需认证）
export async function getPublicConfigValue(key: string): Promise<{ value: string }> {
  return get<{ value: string }>(`/public/config/${key}`);
}
